import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate/src/Formulate';
import CustomMiddleNameField from '~/components/formulate/CustomMiddleNameField.vue';
import CustomListByQueryField from '~/components/formulate/CustomListByQueryField.vue';
import CustomDadataAddressField from '~/components/formulate/CustomDadataAddress.vue';
import CustomDadataCompanyField from '~/components/formulate/CustomDadataCompany.vue';
import CustomDadataPassportField from '~/components/formulate/CustomDadataPassport.vue';
import CustomDadataBankField from '~/components/formulate/CustomDadataBank.vue';
import CustomDadataInputField from '~/components/formulate/CustomDadataInput.vue';
import CustomPhoneInputField from '~/components/formulate/CustomPhoneInput.vue';
import CustomTelegramField from '~/components/formulate/CustomTelegram.vue';
import CustomSearchSelectField from '~/components/formulate/CustomSearchSelect.vue';
import ConfirmSubmit from '~/components/formulate/loyalty/ConfirmSubmit.vue';
import CustomCategoryClubField from '~/components/formulate/CustomCategoryClub.vue';
import CustomProductsSelectField from '~/components/formulate/CustomProductsSelect.vue';
import CustomImageInputField from '~/components/formulate/CustomImageInput.vue';
import CustomSignUpToClubField from '~/components/formulate/CustomSignUpToClub.vue';
import CustomSwitchField from '~/components/formulate/CustomSwitch.vue';
import ButtonToggleHidden from '~/components/formulate/loyalty/ButtonToggleHidden.vue';
import CustomRadioGroupField from '~/components/formulate/CustomRadioGroup.vue';
import CustomClubField from '~/components/formulate/CustomClub.vue';
import CustomDadataInnField from '~/components/formulate/CustomDadataInn.vue';
import CustomDonationAmountInputField from '~/components/formulate/CustomDonationAmountInput.vue';
import CustomEmailVerifyInputField from '~/components/formulate/CustomEmailVerifyInput.vue';
import CustomDadataCountryField from '~/components/formulate/CustomDadataCountry.vue';
import CustomClubMemberField from '~/components/formulate/CustomClubMemberField.vue';
import CustomFileInputField from '~/components/formulate/CustomFileInput.vue';
import FreeParkingFieldGroup from '~/components/formulate/loyalty/FreeParkingFieldGroup.vue';

// register your component with Vue
Vue.component('CustomMiddleNameField', CustomMiddleNameField);
Vue.component('CustomListByQueryField', CustomListByQueryField);
Vue.component('CustomDadataAddressField', CustomDadataAddressField);
Vue.component('CustomDadataCompanyField', CustomDadataCompanyField);
Vue.component('CustomDadataPassportField', CustomDadataPassportField);
Vue.component('CustomDadataBankField', CustomDadataBankField);
Vue.component('CustomDadataInputField', CustomDadataInputField);
Vue.component('CustomDadataInnField', CustomDadataInnField);
Vue.component('CustomDonationAmountInputField', CustomDonationAmountInputField);
Vue.component('CustomPhoneInputField', CustomPhoneInputField);
Vue.component('CustomTelegramField', CustomTelegramField);
Vue.component('CustomSearchSelectField', CustomSearchSelectField);
Vue.component('ConfirmSubmit', ConfirmSubmit);
Vue.component('ButtonToggleHidden', ButtonToggleHidden);
Vue.component('CustomCategoryClubField', CustomCategoryClubField);
Vue.component('CustomProductsSelectField', CustomProductsSelectField);
Vue.component('CustomImageInputField', CustomImageInputField);
Vue.component('CustomSignUpToClubField', CustomSignUpToClubField);
Vue.component('CustomSwitchField', CustomSwitchField);
Vue.component('CustomRadioGroupField', CustomRadioGroupField);
Vue.component('CustomClubField', CustomClubField);
Vue.component('CustomEmailVerifyInputField', CustomEmailVerifyInputField);
Vue.component('CustomDadataCountryField', CustomDadataCountryField);
Vue.component('CustomClubMemberField', CustomClubMemberField);
Vue.component('CustomFileInputField', CustomFileInputField);
Vue.component('FreeParkingFieldGroup', FreeParkingFieldGroup);

Vue.use(VueFormulate, {
	library: {
		customMiddleName: {
			classification: 'text',
			component: 'CustomMiddleNameField',
		},
		CustomListByQuery: {
			classification: 'text',
			component: 'CustomListByQueryField',
		},
		CustomDadataAddress: {
			classification: 'text',
			component: 'CustomDadataAddressField',
		},
		CustomDadataCompany: {
			classification: 'text',
			component: 'CustomDadataCompanyField',
		},
		CustomDadataPassport: {
			classification: 'text',
			component: 'CustomDadataPassportField',
		},
		CustomDadataBank: {
			classification: 'text',
			component: 'CustomDadataBankField',
		},
		CustomDadataInn: {
			classification: 'text',
			component: 'CustomDadataInnField',
		},
		CustomDadataInput: {
			classification: 'text',
			component: 'CustomDadataInputField',
		},
		CustomDonationAmountInput: {
			classification: 'text',
			component: 'CustomDonationAmountInputField',
		},
		CustomPhoneInput: {
			classification: 'text',
			component: 'CustomPhoneInputField',
		},
		CustomTelegramField: {
			classification: 'text',
			component: 'CustomTelegramField',
		},
		CustomSearchSelect: {
			classification: 'text',
			component: 'CustomSearchSelectField',
		},
		CustomCategoryClub: {
			classification: 'text',
			component: 'CustomCategoryClubField',
		},
		CustomProductsSelect: {
			classification: 'text',
			component: 'CustomProductsSelectField',
		},
		ConfirmSubmit: {
			classification: 'submit',
			component: 'ConfirmSubmit',
		},
		ButtonToggleHidden: {
			classification: 'text',
			component: 'ButtonToggleHidden',
		},
		CustomImageInput: {
			classification: 'image',
			component: 'CustomImageInputField',
			slotProps: {
				component: ['wrapper-class'],
			},
		},
		CustomSignUpToClub: {
			classification: 'select',
			component: 'CustomSignUpToClubField',
		},
		CustomSwitch: {
			classification: 'select',
			component: 'CustomSwitchField',
		},
		CustomRadioGroup: {
			classification: 'radio',
			component: 'CustomRadioGroupField',
		},
		CustomClub: {
			classification: 'text',
			component: 'CustomClubField',
		},
		CustomEmailVerifyInput: {
			classification: 'text',
			component: 'CustomEmailVerifyInputField',
		},
		CustomDadataCountry: {
			classification: 'text',
			component: 'CustomDadataCountryField',
		},
		CustomClubMember: {
			classification: 'text',
			component: 'CustomClubMemberField',
		},
		CustomFileInput: {
			classification: 'text',
			component: 'CustomFileInputField',
		},
		FreeParkingFieldGroup: {
			classification: 'text',
			component: 'FreeParkingFieldGroup',
		},
	},
	mimes: {
		doc: 'application/msword',
		docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	},
});

export default VueFormulate;
